import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import Vuelidate from "vuelidate";
import * as VueGoogleMaps from "vue2-google-maps";
import VueMask from "v-mask";
import VueRouter from "vue-router";
import vco from "v-click-outside";
import router from "./router/index";
import Scrollspy from "vue2-scrollspy";
import VueSweetalert2 from "vue-sweetalert2";

import VueCurrencyFilter from "vue-currency-filter";
import "../src/design/app.scss";

import store from "@/state/store";

import App from "./App.vue";

import { initFirebaseBackend } from "./authUtils";
import i18n from "./i18n";

import { configureFakeBackend } from "./helpers/fake-backend";
import ApiService from "./services/api.service";
import tinymce from "vue-tinymce-editor";
import axios from "axios";
import MyPlugin from "./plugins/functions";
import vSelect from "vue-select";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue-select/dist/vue-select.css";
import { abilitiesPlugin } from "@casl/vue";
import { ability } from "./state/ability";
axios.defaults.baseURL = "https://xarid-api.uzedu.uz/";
// axios.defaults.baseURL = "http://eduxarid-api.apptest.uz";
if (window.location.href.indexOf("http://eduxarid.apptest") > -1) {
  axios.defaults.baseURL = "http://eduxarid-api.apptest.uz/";
}
// axios.defaults.baseURL = "http://xarid-api.uzedu.uz";
if (window.location.href.indexOf("http://xarid.uzedu.uz") > -1) {
  axios.defaults.baseURL = "http://xarid-api.uzedu.uz/";
}
if (window.location.href.indexOf("https://xarid.uzedu.uz") > -1) {
  axios.defaults.baseURL = "https://xarid-api.uzedu.uz/";
}
if (window.location.href.indexOf("https://xaridtest.uzedu.uz") > -1) {
  axios.defaults.baseURL = "https://xaridtest-api.uzedu.uz/";
}
if (window.location.href.indexOf("http://xaridtest.uzedu.uz") > -1) {
  axios.defaults.baseURL = "http://xaridtest-api.uzedu.uz/";
}
if (window.location.href.indexOf("http://testxarid.uzedu.uz") > -1) {
  axios.defaults.baseURL = "http://xaridtest-api.uzedu.uz/";
}
if (window.location.href.indexOf("https://testxarid.uzedu.uz") > -1) {
  axios.defaults.baseURL = "https://xaridtest-api.uzedu.uz/";
}

axios.interceptors.request.use((request) => requestInterceptor(request));
const requestInterceptor = (request) => {
  request.withCredentials = true;
  return request;
};

const firebaseConfig = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
  projectId: process.env.VUE_APP_PROJECTId,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APPId,
  measurementId: process.env.VUE_APP_MEASUREMENTID,
};

if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
  initFirebaseBackend(firebaseConfig);
} else {
  configureFakeBackend();
}
const token = localStorage.getItem("auth_token");
if (token) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}
ApiService.mount401Interceptor();
Vue.use(abilitiesPlugin, ability);
Vue.component("tinymce", tinymce);
Vue.use(VueToast, {
  position: "top-right",
});
Vue.use(VueRouter);
Vue.use(vco);
Vue.use(Scrollspy);
const VueScrollTo = require("vue-scrollto");
Vue.use(VueScrollTo);
Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(MyPlugin);
Vue.use(Vuelidate);
Vue.use(VueMask);
Vue.use(require("vue-chartist"));
Vue.use(VueSweetalert2);
Vue.component("v-select", vSelect);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE",
    libraries: "places",
  },
  installComponents: true,
});
Vue.component("apexchart", VueApexCharts);
Vue.use(VueCurrencyFilter, {
  symbol: "c",
  thousandsSeparator: " ",
  fractionCount: 0,
  fractionSeparator: ",",
  symbolPosition: "back",
  symbolSpacing: true,
});
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
